'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');

var appDom = require('./app-dom');

var onShareClicked = function(e) {

	var markup = '<div class="notify-share__icons">' +
					 '<a href="#" data-network="facebook" class="notify-share__icon notify-share__icon--facebook sites-icon sites-icon--facebook"></a>' +
					 '<a href="#" data-network="twitter" class="notify-share__icon notify-share__icon--twitter sites-icon sites-icon--twitter"></a>' +
					 '<a href="#" data-network="pinterest" class="notify-share__icon notify-share__icon--pinterest sites-icon sites-icon--pinterest"></a>' + 
				 '</div>';

	notify.show({
		target: $(this),
		msg: markup,
		position: 'bottom',
		type: 'share',
		customClasses: 'share-class',
		buffer: -40
	});

};

var onSocialNetworkIconClick = function(e) {

	var $icon = $(this);
	var network = $icon.attr('data-network');
	var url = '/social/social_networking.cfm?type=default&networkID=';
	var returnUrl = window.encodeURIComponent($('meta[property="og:url"]').attr('content'));
	var title = window.encodeURIComponent($('meta[property="og:title"]').attr('content'));
	var description = window.encodeURIComponent($('meta[property="og:description"]').attr('content'));
	var imagePath = window.encodeURIComponent($('meta[property="og:image"]').attr('content'));

	e.preventDefault();

	if (network === 'facebook') {

		url += 'facebook';

	} else if (network === 'twitter') {

		url += 'twitter&text=' + description;

	} else if (network === 'pinterest') {

		url += 'pinterest&image_url=' + imagePath;

	}

	url += '&title=' + title;
	url += '&linkBack=' + returnUrl + '&ts=' + Date.now();

	window.open(url, '_blank');

};

var init = function() {

	var $shareIcons = $('.js-show-share-popup');

	if ($shareIcons.length) {
		
		// register share icon click handler
		$shareIcons.on('click', onShareClicked);

		// register social network click handler
		appDom.document.on('click', '.notify-share__icon', onSocialNetworkIconClick);

	}

};

module.exports = {
	init: init
};
